module.exports = "query GetReminders($offset: Int, $limit: Int) {\n  reminders(offset: $offset, limit: $limit) {\n    ...MinimalReminderFragment\n  }\n}\n"